























import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch,
  Mixins
} from "vue-property-decorator";
import ImgFetched from "@/components/ImgFetched/ImgFetched.vue";
@Component({
  components: {
    ImgFetched
  }
})
export default class OrderMsg extends Vue {
  @Prop()
  private effect: any;
  @Prop()
  private icon: any;
  @Prop()
  private kind: any;
  @Prop()
  private text: any;
  @Prop()
  private iconClass: any;
  @Prop()
  private cub: any;
  get title() {
    return this.kind === "free_follow"
      ? "Free Followers Awarded"
      : "Order Completed";
  }

  @Emit("clickOk")
  private clickOk() {
    //
  }
}
